"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi"));
var _systemSetting = require("@/api/systemSetting");
var _auth = require("@/utils/auth");
var _internal = require("@/components/uploadPicture/internal.js");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 导入本地上传工具函数
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      TYPE_MAP: [{
        name: '自营商品',
        value: 1
      }, {
        name: '福司令商品',
        value: 2
      }, {
        name: '蛋糕商品',
        value: 3
      }],
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      showCateIdOption: [],
      customersLists: [],
      timer: [],
      dialogAddVisible: false,
      visibility: false,
      detailsList: [],
      batchId: null,
      statusNum: null,
      visibilitySelf: false,
      detailsListSelf: [],
      pollingTimer: null,
      cpStatusEnum: [{
        label: '资料准备中',
        value: 1
      }, {
        label: '可采集',
        value: 2
      }, {
        label: '已入库',
        value: 3
      }, {
        label: '暂不入库',
        value: 4
      }, {
        label: '临时下架',
        value: 5
      }],
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      skuImagesNew: [],
      imgesType: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handleList();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearPollingTimer();
  },
  watch: {
    visibility: function visibility(newValue) {
      if (newValue) {
        // Start polling when dialog opens
        this.startPollingTimer();
      } else {
        // Stop polling when dialog closes
        this.clearPollingTimer();
        // Refresh the list when dialog closes
        this.handleList();
      }
    },
    dialogAddVisible: function dialogAddVisible(newValue) {
      if (!newValue) {
        // Refresh the list when upload dialog closes
        this.handleList();
      }
    }
  },
  methods: {
    // Clear polling timer
    clearPollingTimer: function clearPollingTimer() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    // Start polling timer to fetch logs every second
    startPollingTimer: function startPollingTimer() {
      var _this2 = this;
      this.clearPollingTimer();
      this.pollingTimer = setInterval(function () {
        _this2.fetchLogsData();
      }, 1000);
    },
    // Fetch latest logs data
    fetchLogsData: function () {
      var _fetchLogsData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, terminalStates, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.batchId) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return (0, _store.batchLogs)({
                batchId: this.batchId
              });
            case 2:
              res = _context.v;
              this.detailsList = res.logs;
              this.statusNum = res.status;

              // 如果是执行成功(23)，部分成功(22)，暂停(31)，异常(41)都不用再查询了
              // 其他状态需要持续查询
              // Status codes:
              // UPLOAD_SUCCESS(0), ANALYSIS_ING(1), ANALYSIS_FAIL(2), ANALYSIS_SUCCESS(3),
              // CHECK_ING(11), CHECK_FAIL(12), CHECK_SUCCESS(13), 
              // EXEC_ING(21), EXEC_PART_SUCCESS(22), EXEC_SUCCESS(23),
              // STOP_ING(31), EXCEPT(41)
              terminalStates = [22, 23, 31, 41];
              if (terminalStates.includes(res.status)) {
                this.clearPollingTimer();
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('Error fetching logs data:', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function fetchLogsData() {
        return _fetchLogsData.apply(this, arguments);
      }
      return fetchLogsData;
    }(),
    handleList: function () {
      var _handleList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _store.batchList)(_objectSpread(_objectSpread({}, this.listPram), {}, {
                startTime: this.timer[0],
                endTime: this.timer[1]
              }));
            case 1:
              res = _context2.v;
              this.listData.list = res.batchInfo.list;
              this.listData.total = res.batchInfo.total;
              this.customersLists = res.statusList;
              this.listLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleList() {
        return _handleList.apply(this, arguments);
      }
      return handleList;
    }(),
    handleTimerChange: function handleTimerChange(val) {
      this.timer = val ? val : [];
      this.handleList();
    },
    beforeUpload: function () {
      var _beforeUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(file) {
        var _res$data,
          _this3 = this;
        var formData, res, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              _context4.n = 1;
              return (0, _store.batchFileName)(file.name);
            case 1:
              res = _context4.v;
              console.log(res, 'RES');
              if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 601)) {
                _context4.n = 2;
                break;
              }
              this.$confirm(res.data.msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                var data;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return (0, _store.batchTask)(formData);
                    case 1:
                      data = _context3.v;
                      _this3.handleDalst(data);
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              })));
              _context4.n = 4;
              break;
            case 2:
              _context4.n = 3;
              return (0, _store.batchTask)(formData);
            case 3:
              data = _context4.v;
              this.handleDalst(data);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function beforeUpload(_x) {
        return _beforeUpload.apply(this, arguments);
      }
      return beforeUpload;
    }(),
    addDowExcel: function () {
      var _addDowExcel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return (0, _store.batchTemplate)();
            case 1:
              res = _context5.v;
              if (res.fileName) {
                window.open(res.fileName);
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      function addDowExcel() {
        return _addDowExcel.apply(this, arguments);
      }
      return addDowExcel;
    }(),
    handleDalst: function () {
      var _handleDalst = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(id) {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.batchId = id;
              _context6.n = 1;
              return (0, _store.batchLogs)({
                batchId: id
              });
            case 1:
              res = _context6.v;
              this.detailsList = res.logs;
              this.statusNum = res.status;
              this.visibility = true;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function handleDalst(_x2) {
        return _handleDalst.apply(this, arguments);
      }
      return handleDalst;
    }(),
    handleStoppopgetion: function () {
      var _handleStoppopgetion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this4 = this;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              this.$confirm(this.statusNum === 21 ? '暂停任务部分数据无法保存，确认需要暂停吗?' : '确定继续当前任务吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.n) {
                    case 0:
                      _context7.n = 1;
                      return (0, _store.batchTurnTask)(_this4.batchId);
                    case 1:
                      _this4.$message.success('执行成功');
                      _this4.visibility = false;
                      _this4.handleList();
                    case 2:
                      return _context7.a(2);
                  }
                }, _callee7);
              })));
            case 1:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function handleStoppopgetion() {
        return _handleStoppopgetion.apply(this, arguments);
      }
      return handleStoppopgetion;
    }(),
    handlerDelete: function () {
      var _handlerDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(batchId, status) {
        var _this5 = this;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              this.$confirm(status === 21 ? '暂停任务部分数据无法保存，确认需要暂停吗?' : '确定继续当前任务吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
                return _regenerator().w(function (_context9) {
                  while (1) switch (_context9.n) {
                    case 0:
                      _context9.n = 1;
                      return (0, _store.batchTurnTask)(batchId);
                    case 1:
                      _this5.$message.success('执行成功');
                      _this5.handleList();
                    case 2:
                      return _context9.a(2);
                  }
                }, _callee9);
              })));
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function handlerDelete(_x3, _x4) {
        return _handlerDelete.apply(this, arguments);
      }
      return handlerDelete;
    }(),
    handleGoods: function () {
      var _handleGoods = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(id) {
        var res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return (0, _store.batchTurnTaskList)({
                batchId: id
              });
            case 1:
              res = _context1.v;
              this.detailsListSelf = res;
              this.visibilitySelf = true;
            case 2:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function handleGoods(_x5) {
        return _handleGoods.apply(this, arguments);
      }
      return handleGoods;
    }(),
    //上传图片
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var _this;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              // 使用Windows本地文件上传方式
              _this = this;
              window.$loading = this.$loading;
              (0, _internal.uploadLocalImage)({
                multiple: true,
                maxCount: 5,
                model: 'product',
                pid: 1,
                onSuccess: function () {
                  var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(url) {
                    return _regenerator().w(function (_context10) {
                      while (1) switch (_context10.n) {
                        case 0:
                          if (!_this.imgesType) {
                            _context10.n = 2;
                            break;
                          }
                          _this.skuImagesNew.skuImages.push(url);
                          _context10.n = 1;
                          return (0, _store.batchImage)({
                            id: _this.skuImagesNew.skuId,
                            images: _toConsumableArray(_this.skuImagesNew.skuImages)
                          });
                        case 1:
                          _context10.n = 3;
                          break;
                        case 2:
                          _this.skuImagesNew.images.push(url);
                          _context10.n = 3;
                          return (0, _store.batchSpuImage)({
                            id: _this.skuImagesNew.productId,
                            images: _toConsumableArray(_this.skuImagesNew.images)
                          });
                        case 3:
                          _this.$message.success('图片上传成功');
                        case 4:
                          return _context10.a(2);
                      }
                    }, _callee10);
                  }));
                  function onSuccess(_x6) {
                    return _onSuccess.apply(this, arguments);
                  }
                  return onSuccess;
                }(),
                onError: function onError(error) {
                  _this.$message.error(error.message || '上传失败');
                }
              });
            case 1:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function handleUploadForm() {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    handleSkuId: function handleSkuId(item) {
      this.skuImagesNew = null;
      this.skuImagesNew = item;
      this.imgesType = true;
    },
    handleSpuId: function handleSpuId(item) {
      this.skuImagesNew = null;
      this.skuImagesNew = item;
      this.imgesType = false;
    },
    onchangeIsShowSpu: function () {
      var _onchangeIsShowSpu = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(row) {
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              if (!row.status) {
                _context12.n = 2;
                break;
              }
              _context12.n = 1;
              return (0, _store.batchPutOnShell)(row.productId);
            case 1:
              this.$message.success('上架成功');
              _context12.n = 4;
              break;
            case 2:
              _context12.n = 3;
              return (0, _store.batchOffShellt)(row.productId);
            case 3:
              this.$message.success('下架成功');
            case 4:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function onchangeIsShowSpu(_x7) {
        return _onchangeIsShowSpu.apply(this, arguments);
      }
      return onchangeIsShowSpu;
    }(),
    onchangeIsShowSku: function () {
      var _onchangeIsShowSku = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(row) {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return (0, _store.batchUpdateStatus)({
                status: row.status,
                id: row.skuId
              });
            case 1:
              if (row.status) {
                this.$message.success('上架成功');
              } else {
                this.$message.success('下架成功');
              }
            case 2:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function onchangeIsShowSku(_x8) {
        return _onchangeIsShowSku.apply(this, arguments);
      }
      return onchangeIsShowSku;
    }(),
    handleChangeStatus: function () {
      var _handleChangeStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(row) {
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _context14.n = 1;
              return (0, _store.batchUpdateCpStatus)({
                status: row.cpStatus,
                id: row.skuId
              });
            case 1:
              this.$message.success('修改成功');
            case 2:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function handleChangeStatus(_x9) {
        return _handleChangeStatus.apply(this, arguments);
      }
      return handleChangeStatus;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleList();
    },
    handleDelete: function () {
      var _handleDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(item, index) {
        var _this$skuImagesNew;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              this.skuImagesNew = item;
              if (!((_this$skuImagesNew = this.skuImagesNew) !== null && _this$skuImagesNew !== void 0 && _this$skuImagesNew.skuImages)) {
                _context15.n = 2;
                break;
              }
              this.skuImagesNew.skuImages.splice(index, 1);
              _context15.n = 1;
              return (0, _store.batchImage)({
                id: this.skuImagesNew.skuId,
                images: _toConsumableArray(this.skuImagesNew.skuImages)
              });
            case 1:
              _context15.n = 3;
              break;
            case 2:
              this.skuImagesNew.images.splice(index, 1);
              _context15.n = 3;
              return (0, _store.batchSpuImage)({
                id: this.skuImagesNew.productId,
                images: _toConsumableArray(this.skuImagesNew.images)
              });
            case 3:
              return _context15.a(2);
          }
        }, _callee15, this);
      }));
      function handleDelete(_x0, _x1) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    uploadItem: function uploadItem(param) {
      var _this6 = this;
      var formData = new FormData();
      var data = {
        model: 'supplier',
        pid: 10
      };
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return (0, _systemSetting.fileImageApi)(formData, data).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(res) {
          return _regenerator().w(function (_context16) {
            while (1) switch (_context16.n) {
              case 0:
                if (!_this6.imgesType) {
                  _context16.n = 2;
                  break;
                }
                _this6.skuImagesNew.skuImages.push(res.url);
                _context16.n = 1;
                return (0, _store.batchImage)({
                  id: _this6.skuImagesNew.skuId,
                  images: _toConsumableArray(_this6.skuImagesNew.skuImages)
                });
              case 1:
                _context16.n = 3;
                break;
              case 2:
                console.log('batchSkuImage');
                _this6.skuImagesNew.images.push(res.url);
                _context16.n = 3;
                return (0, _store.batchSpuImage)({
                  id: _this6.skuImagesNew.productId,
                  images: _toConsumableArray(_this6.skuImagesNew.images)
                });
              case 3:
                loading.close();
                _this6.$message.success('上传成功');
              case 4:
                return _context16.a(2);
            }
          }, _callee16);
        }));
        return function (_x10) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (res) {
        loading.close();
      });
    }
  }
};